import React, {Fragment} from "react";
import {getTimestampFormattato} from "../../../../utility/common";
import ModalConfirm from "../../../../components/ModalConfirm";
import ModalMsg from "../../../../components/ModalMsg";
import DataTableCmms from "../../../../components/tabelle/NsDataTable";
import NsButtonActionsGroup from "../../../../components/buttons/NsButtonActionsGroup";
import NsButtonAction from "../../../../components/buttons/NsButtonAction";

export default function TabellaDocumentiKpiView({
                                                    showConfirm,
                                                    setShowConfirm,
                                                    elimina,
                                                    translate,
                                                    docSel,
                                                    show,
                                                    setShow,
                                                    modalMsg,
                                                    loadingData,
                                                    documenti,
                                                    downloadDocumento,
                                                    setDocSel,
                                                }) {

    return (
        <Fragment>
            <ModalConfirm
                show={showConfirm}
                handleClose={() => setShowConfirm(false)}
                handleOk={elimina}
                testo={translate("Sicuro di voler eliminare il documento: ") + (docSel && (docSel.nome_file_originale)) + "?"}/>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <div className={"row"}>
                <div className="col-md-12 table-responsive">
                    <DataTableCmms
                        data={documenti}
                        columns={[
                            {
                                name: translate('File'),
                                selector: row => row.nome_file_originale,
                                sortable: true,
                            },
                            {
                                name: translate('Descrizione'),
                                selector: row => row.descrizione || '-',
                                sortable: true,
                            },
                            {
                                name: translate('Utente'),
                                selector: row => row.usr_ins,
                                sortable: true,
                            },
                            {
                                name: translate('Data upload'),
                                selector: row => getTimestampFormattato(row.data_ins),
                                sortable: true,
                            },
                            {
                                name: '',
                                selector: row => <NsButtonActionsGroup>
                                    <li>
                                        <NsButtonAction
                                            label={"Scarica"}
                                            icona={"fas fa-download"}
                                            onClick={() => {
                                                downloadDocumento(row, true)
                                            }}
                                        />
                                    </li>
                                    <li>
                                        <NsButtonAction
                                            label={"Visualizza"}
                                            icona={"fas fa-eye"}
                                            onClick={() => {
                                                downloadDocumento(row, false);
                                            }}
                                        />
                                    </li>
                                    <li>
                                        <NsButtonAction
                                            label={"Elimina"}
                                            icona={"fas fa-trash"}
                                            onClick={() => {
                                                setDocSel(row);
                                                setShowConfirm(true);
                                            }}
                                        />
                                    </li>
                                </NsButtonActionsGroup>,
                                sortable: false,
                                right: true,
                            }
                        ]}
                    >
                    </DataTableCmms>
                </div>
            </div>
        </Fragment>
    );
}
